<span>
  <i *ngIf="showOnlyIcon" class="fa" [ngClass]="icon" tooltip="{{title}}" data-placement="bottom"></i>
  <span *ngIf="showOnlyTitle" class="inspection-type-text">{{title}}</span>
  <span *ngIf="!showOnlyIcon && !showOnlyTitle">
    <i class="fa" [ngClass]="icon"></i>
    <span class="inspection-type-text">{{title}}</span>
  </span>
</span>
